import type { Step } from "react-joyride";

export const promotionRecordEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ແກ້ໄຂບັນທຶກການເລື່ອນຕຳແໜ່ງ. ປ່ຽນແປງຂໍ້ມູນ ແລ້ວກົດບັນທຶກ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-record-edit-back"]',
    content:
      "ຍົກເລີກ ແລະ ກັບໄປຫນ້າລາຍການບັນທຶກການເລື່ອນຕຳແໜ່ງ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-record-edit-form"]',
    content:
      "ແກ້ໄຂຂໍ້ມູນພະນັກງານ, ຕຳແໜ່ງ, ລະດັບ, ເງິນເດືອນ ແລະ ວັນທີ. ກົດບັນທຶກເພື່ອອັບເດດ.",
    placement: "top",
  },
];
